module.controller('loanCntrl', function(services, esb, $scope, $mdDialog, $window, xmppAuth, cryptool) {

  $scope.metadata  = JSON.parse($window.localStorage.getItem("metadataObj"));
  $scope.loan = {};
  $scope.detailsInfo = "ok";
  $scope.showItemDetails = {};

  $scope.metadata.lenderList.forEach(function(item, index) {
    $scope.image = esb +"/security/lender/avatar/"+item.entity.id;
  });
  $scope.iconEsb = esb+"/security";
  console.log("esb es: " + esb);

  $scope.closeDialog = function(){
    $mdDialog.cancel();
  };

  $scope.selectOption = function(programId, program, index, item){
    $scope.loan.lenderId = item.entity.id;
    $scope.loan.programId = programId;
    $scope.loan.program = program;

    for(var i=0; i<item.programs.length; i++ ){
      if(i === index)
        document.getElementById("select_icon"+index).src="../images/iconsChat/confirmation.png";
      else document.getElementById("select_icon"+i).src="../images/iconsChat/grayyes.png";
    }
  }

  $scope.onPositionUpdate = function(position) {
    $window.localStorage.setItem("locationPermission", "true");
    $scope.latitude = position.coords.latitude;
    $scope.longitude = position.coords.longitude;
  }
  if (navigator.geolocation){
    var showLockMessage = false;
    if(!$window.localStorage.getItem("locationPermission")){

    } else{
      if( $window.localStorage.getItem("locationPermission") && $window.localStorage.getItem("locationPermission") === 'lock')
        showLockMessage = true;
    }
    navigator.geolocation.getCurrentPosition($scope.onPositionUpdate, function (err){
      switch (err.code) {
          // PERMISSION_DENIED
        case 1:
          console.log('Permission denied')
          $window.localStorage.setItem("locationPermission", "lock");
          break
          // POSITION_UNAVAILABLE
        case 2:
          console.log('Permission allowed, location disabled')
          break
          // TIMEOUT
        case 3:
          console.log('Permission allowed, timeout reached')
          break
      }
      $scope.latitude = 0.0;
      $scope.longitude = 0.0;
    });

  }
  else{
    $scope.latitude = 0.0;
    $scope.longitude = 0.0;
  }

  $scope.selectedProgram = function(){
      $scope.progressCircular = "ok";
      switch($scope.loan.program.type) {
        case "REVOLVING_CREDIT":
              if(!$scope.loan.program.revolvingCreditActivated | ($scope.loan.program.revolvingCreditActivated && $scope.loan.program.revolvingCreditAccountBalance > 0))
                {
                  var originationInstrutions = {
                    agaHeader: $scope.loan.program.originationInstructions.agaHeader,
                    agaEvent: $scope.loan.program.originationInstructions.agaEvent,
                    agaOriginationType: $scope.loan.program.originationInstructions.agaOriginationType
                  }

                  var requestRevolvingCredit = {
                      lenderId: $scope.loan.lenderId,
                      lenderProgramId: $scope.loan.program.id,
                      originationInstructions: originationInstrutions,
                      revolvingCreditActivated: $scope.loan.program.revolvingCreditActivated ? true : false,
                      agentTellerUser: $window.sessionStorage.getItem('user_teller_agent')
                    }

                  services.revolvingCreditLoanRequest('bearer ' + $window.localStorage.getItem('access_token1')).entityLoan({}, requestRevolvingCredit, function(response) {
                    $scope.progressCircular = undefined;
                    switch(response.code) {
                      case 1:
                        $scope.closeDialog();
                        break;
                      case -500:
                        $scope.showAlert('No se pudo crear el crédito, por favor intente más tarde');
                        break;
                    }
                  });
                }
            else
              $scope.showAlert('Disculpe, no tiene monto disponible para la solicitud de crédito.');
          break;
          default:
            if ($scope.metadata.type_meta == "ACTION"){
              $scope.progressCircular = undefined;
              if($scope.loan.programId){
                var xmpp_domain = cryptool.decryptData($window.sessionStorage.getItem("serviceName"));
                var xmppUser = $window.sessionStorage.getItem('userXmpp');
                var message = "";
                var value =  $scope.loan.programId;
                var entityValues = {
                  "AgentData.userName" : $window.sessionStorage.getItem('user_teller_agent'),
                  "Location.latitude" : $scope.latitude,
                  "Location.longitude" : $scope.longitude
                };
                if ($scope.loan.program){
                  message = $scope.loan.program.name;
                } else {
                  message = "Seleccionado "+value;
                }
                xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, value, message, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, null, null, entityValues);
                $scope.metadataObj = undefined;
                $scope.closeDialog();
              }
            } else {
              $scope.request = {
                lenderId: $scope.loan.lenderId,
                lenderProgramId: $scope.loan.programId,
                agentTellerUser: $window.sessionStorage.getItem('user_teller_agent')
              }
              let params = {
                lat : $scope.latitude,
                lon : $scope.longitude
              };
              services.loanRequest('bearer ' + $window.localStorage.getItem('access_token1'), params).entityLoan({}, $scope.request, function(response) {
                $scope.progressCircular = undefined;
                switch(response.code) {
                  case 1:
                    $scope.closeDialog();
                    break;
                  case -500:
                    $scope.showAlert('No se pudo crear el crédito, por favor intente más tarde');
                    break;
                }
              });
            }
      }
    	/*$scope.progressCircular = "ok";
      if($scope.loan.program.type == "REVOLVING_CREDIT")
      {
        if(!$scope.loan.program.revolvingCreditActivated | ($scope.loan.program.revolvingCreditActivated && $scope.loan.program.revolvingCreditAccountBalance > 0))
        {
          var originationInstrutions = {
            agaHeader: $scope.loan.program.originationInstructions.agaHeader,
            agaEvent: $scope.loan.program.originationInstructions.agaEvent,
            agaOriginationType: $scope.loan.program.originationInstructions.agaOriginationType
          }

          var requestRevolvingCredit = {
              lenderId: $scope.loan.lenderId,
              lenderProgramId: $scope.loan.program.id,
              originationInstructions: originationInstrutions,
              revolvingCreditActivated: $scope.loan.program.revolvingCreditActivated ? true : false
            }

            services.revolvingCreditLoanRequest('bearer ' + $window.localStorage.getItem('access_token1')).entityLoan({}, requestRevolvingCredit, function(response) {
              $scope.progressCircular = undefined;
              switch(response.code) {
                case 1:
                  $scope.closeDialog();
                  break;
                case -500:
                  $scope.showAlert('No se pudo crear el crédito, por favor intente más tarde');
                  break;
              }
            });
          }
          else
            $scope.showAlert('Disculpe, no tiene monto disponible para la solicitud de crédito.');
      }
      else
      {
        $scope.request = {lenderId: $scope.loan.lenderId, lenderProgramId: $scope.loan.programId}
        services.loanRequest('bearer ' + $window.localStorage.getItem('access_token1')).entityLoan({}, $scope.request, function(response) {
          $scope.progressCircular = undefined;
          switch(response.code) {
            case 1:
              $scope.closeDialog();
              break;
            case -500:
              $scope.showAlert('No se pudo crear el crédito, por favor intente más tarde');
              break;
          }
        });
    }*/
  }

  $scope.showAlert = function(message) {
      $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('Error')
          .textContent(message)
          .ariaLabel('Alert Dialog Demo')
          .ok('Ok')
      );
  };

  $scope.toggleDetail = function(index, program) {
    
    if(program && program.programDetailInfo && program.programDetailInfo.detail &&  program.programDetailInfo.detail.expand){
      program.programDetailInfo.detail.expand = false;
      $scope.showItemDetails[index] = true;      
    }
    
    
    if (!$scope.showItemDetails[index]) {     
      $scope.detailsInfo = undefined;        
      $scope.showItemDetails[index] = true;
  } else {          
    $scope.showItemDetails[index] = false;
      $scope.detailsInfo = "ok";
      
  }
   }

   $scope.showInfo = function(index, metadata) {
    
};
});


